import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";

import { externalpageTypes } from "../../shared/services/externalpage.service";
import { AdminExternalpagesComponent } from "../admin-externalpages/admin-externalpages.component";

@Component({
  selector: "app-admin-externalpage-schools",
  templateUrl: "./admin-externalpage-schools.component.html",
  styleUrls: ["./admin-externalpage-schools.component.scss"],
  standalone: false,
})
export class AdminExternalpageSchoolsComponent
  extends AdminExternalpagesComponent
  implements OnInit
{
  externalpageTypes = externalpageTypes;

  override configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Publication date",
        name: "publicationDate",
        type: "date",
      },
      {
        header_name: "Title",
        name: "title",
        type: "text",
      },
      {
        header_name: "Type",
        name: "schoolType",
        type: "text",
      },
      {
        header_name: "Status",
        name: "status",
        type: "text",
      },
      {
        header_name: "Regions",
        name: "regions",
        type: "array",
      },
    ],
    endpoint: "externalpage",
    queryParams: {
      PageType: externalpageTypes.School,
    },
    data: <any>[],
    buttons: [
      {
        class: "btn btn-danger",
        event: "delete",
        text: "Delete",
      },
      {
        class: "btn btn-warning",
        event: "edit",
        text: "Edit",
      },
    ],
    class: "",
    reloadListener: new Subject(),
  };

  override ngOnInit(): void {}

  override handleButtonEvent($event: any) {
    super.handleButtonEvent($event);
  }
}
